import { z } from "zod";

import { dateSchema } from "./utils";

const embeddedAnnouncementSchema = z.object({
  id: z.string(),
  advertiser_name: z.string(),
  headline: z.string(),
  description: z.string(),
  cta_label: z.string(),
  cta_url: z.string(),
  logo: z.string().nullable().catch(null),
  starts_at: dateSchema.nullable().catch(null),
  ends_at: dateSchema.nullable().catch(null),
  live_cta_label: z.string().nullable().catch(null),
  live_cta_url: z.string().nullable().catch(null),
});

type EmbeddedAnnouncement = z.infer<typeof embeddedAnnouncementSchema>;

type EmbeddedAnnouncementState = "default" | "upcoming" | "live";

export {
  embeddedAnnouncementSchema,
  type EmbeddedAnnouncement,
  type EmbeddedAnnouncementState,
};
